import { render } from "./BannerList.vue?vue&type=template&id=041f9161&ts=true"
import script from "./BannerList.vue?vue&type=script&lang=ts"
export * from "./BannerList.vue?vue&type=script&lang=ts"

import "./BannerList.vue?vue&type=style&index=0&id=041f9161&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__